// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-invite {
    text-align: center;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
}
.user-invite__invitations-available {
    text-align: center;
    font-size: 16px;
    padding: 10px;
}
.user-invite__input-wrapper {
    display: flex;
}
.user-invite .user-invite__input-wrapper input[type=text] {
    display: inline-block;
    font-size: 16px;
    margin: 0 10px;
    border-radius: 7px;
    flex-grow: 1
}
.user-invite__success {
    margin: 10px auto;
}
`, "",{"version":3,"sources":["webpack://./client/components/users/input/UserInvite.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB;AACJ;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".user-invite {\n    text-align: center;\n    width: 100%;\n    max-width: 750px;\n    margin: 0 auto;\n}\n.user-invite__invitations-available {\n    text-align: center;\n    font-size: 16px;\n    padding: 10px;\n}\n.user-invite__input-wrapper {\n    display: flex;\n}\n.user-invite .user-invite__input-wrapper input[type=text] {\n    display: inline-block;\n    font-size: 16px;\n    margin: 0 10px;\n    border-radius: 7px;\n    flex-grow: 1\n}\n.user-invite__success {\n    margin: 10px auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
